(function() {
    'use strict';

    var component = {
        transclude: true,
        templateUrl:
            'app/js/components/hidden-passwords/masked-password-component/masked-password.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmSPMP",
        bindings: {
            ngModel: '=',
            placeholder: '@',
            name: '@',
            class: '@',
            ngRequired: '='
        }
    };

    iteroComponents.component('maskedPassword', component);

    function controller() {

        var ctrl = this;
        ctrl.required = false;
        ctrl.handleModeChange = function () {
            ctrl.collapsedMode = false;
            ctrl.ngModel = "";
            ctrl.required = ctrl.ngModel != null && ctrl.ngRequired;
        };

        ctrl.$onInit = function () {
            ctrl.collapsedMode = ctrl.ngModel == null;
            ctrl.required = !ctrl.collapsedMode && ctrl.ngRequired;
        };

        ctrl.$doCheck = function () {
            ctrl.required = ctrl.ngRequired;
        };
    }
})();